import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { isTruthy } from 'lib/Helpers';

import * as styles from './RouterLinkCellRenderer.scss';

/**
 * Returns Given <Link /> to `props.createPath`
 * @function RouterLinkCellRenderer
 * @param {Object} props
 * @return {(ReactElement|String)}
 */
const RouterLinkCellRenderer = ({ cellData = '', createPath = () => {} }) => isTruthy(cellData)
  ? (
    <Link className={styles.link} to={createPath(cellData)}>
      {cellData}
    </Link>
  )
  : '-';

RouterLinkCellRenderer.propTypes = {
  cellData: PropTypes.string,
  createPath: PropTypes.func,
};

export default RouterLinkCellRenderer;
